import { useMediaQuery, useTheme } from "@material-ui/core";

interface UseMobile {
  isMobile: boolean;
}

const useMobile = (): UseMobile => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return { isMobile };
};

export default useMobile;
